import JobOpening from 'interview/services/job-opening'
import { httpError } from 'actions/http'
import { replace } from 'react-router-redux'
import { actions } from 'react-redux-form'
import CandidateService from 'interview/services/candidate'
import { setLanguage, setShowIntercom } from 'actions'

import { languages } from 'i18n'
import { browserHistory } from 'react-router'
import candidate from 'interview/services/candidate'

export const JOB_OPENING_RECEIVE = 'JOB_OPENING_RECEIVE'

export const receiveJobOpening = payload => ({ type: JOB_OPENING_RECEIVE, payload })


export const fetchJobOpening = (params, isPublic, isEmbedded) => dispatch => {
  const id = params.uuid || params.token
  return JobOpening.get(id, isEmbedded)
.then(jobOpening => {
      dispatch(receiveJobOpening(jobOpening))
      dispatch(setShowIntercom(jobOpening.company))
      // Change UI language based on openings language setting
      if (jobOpening.language in languages) {
        dispatch(setLanguage(jobOpening.language))
      } else {
        // Fallback to english
        dispatch(setLanguage('en'))
      }
    })
    .catch((err) => {
      // TODO: should we show intercom messenger here? We don't have the company data here
      // so it also shows our own support email in the footer even if there was custom support enabled (should probably be fixed too)
      if (err.response && err.response.status && err.response.status === 404) {
        if (isPublic) {
          dispatch(replace('/public/closed'))
        } else {
          dispatch(replace('/closed'))
        }
      } else {
        throw err
      }
    })
}

export const fetchEmbeddedJobOpeningAndCandidate =
(params, candidateInfo) => dispatch => {
    const id = params.uuid || params.token
    if (candidateInfo && candidateInfo.email && candidateInfo.candidate) {
      return JobOpening.get(id, true).then(jobOpening => {
          return CandidateService.getEmbeddedCandidate({
            email: candidateInfo.email,
            atsCandidateId: candidateInfo.candidate,
            opening: jobOpening._id || jobOpening.profileUuid,
          }).then(candidate => {
            if (candidate) {
              candidate.videoResponses.map(response => {
                response.has = !!response.videoUrl
              })
              dispatch(actions.change('candidate', candidate))
            } else {
              dispatch(
                actions.merge('candidate', {
                  email: candidateInfo.email,
                  atsCandidateId: candidateInfo.candidate,
                })
              )
            }
            dispatch(receiveJobOpening(jobOpening))
            // Change UI language based on openings language setting
            if (jobOpening.language in languages) {
              dispatch(setLanguage(jobOpening.language))
            } else {
              // Fallback to english
              dispatch(setLanguage('en'))
            }
          })
        })
        .catch((err) => {
          if (err.response && err.response.status && err.response.status === 404) {
            dispatch(replace('/interview/profile/closed'))
          } else {
            throw err
          }
        })
    } else {
      return dispatch(fetchJobOpening(params, false, true))
    }
  }

export const startInterview = payload => (dispatch, getState) => {
  const { files } = getState().global

  // Fetch data uris from global files list (this is how attachments component works)
  const attachments = Array.isArray(payload.candidate.attachments)
    ? payload.candidate.attachments.map(attachment => attachment.key in files ? { ...attachment, datauri: files[attachment.key] } : attachment)
    : undefined

  return JobOpening.createCandidate(
    payload.uuid,
    { ...payload.candidate, attachments },
    payload.isEmbedded
  )
    .then(candidate => {
      dispatch(actions.change('candidate', candidate))
      return candidate
    })
    .catch(err => {
      if (err.response && err.response.status === 404) {
        dispatch(httpError(err.response.status))
      } else {
        throw err
      }
    })
}
